// extracted by mini-css-extract-plugin
module.exports = {"container_payment":"Payment_container_payment__1i90d","personal_title":"Payment_personal_title__2zQ5I","productTitle":"Payment_productTitle__3OKWQ"};